import { Component, inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matAddBoxOutline } from '@ng-icons/material-icons/outline';
import { TranslateModule } from '@ngx-translate/core';

import { AddHomeScreenGuideDialogComponent } from './add-home-screen-guide-dialog/add-home-screen-guide-dialog.component';

@Component({
  selector: 'app-add-home-screen',
  templateUrl: './add-home-screen.component.html',
  imports: [NgIcon, TranslateModule],
  viewProviders: [provideIcons({ matAddBoxOutline })],
})
export class AddHomeScreenComponent implements OnInit {
  deferredPrompt: unknown;
  showInstallButton = true;
  isInStandaloneMode = false;

  private readonly modalService = inject(NgbModal);

  ngOnInit(): void {
    this.isInStandaloneMode = this.detectStandaloneMode();

    globalThis.addEventListener('beforeinstallprompt', e => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallButton = true;
    });

    globalThis.addEventListener('appinstalled', () => {
      this.showInstallButton = false;
      this.deferredPrompt = null;
    });
  }

  addToHomeScreen() {
    // If Browser support Prompt
    if (this.deferredPrompt) {
      this.deferredPrompt['prompt']();
      this.deferredPrompt['userChoice'].then(
        (choiceResult: { outcome: string }) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted A2HS prompt');
          } else {
            console.log('User dismissed A2HS prompt');
          }
          this.deferredPrompt = null;
          this.showInstallButton = false;
        }
      );
    } else {
      this.modalService
        .open(AddHomeScreenGuideDialogComponent, {
          fullscreen: true,
          ariaLabelledBy: 'add-home-screen-guide-title',
          windowClass: 'add-home-screen-guide-modal',
        })
        .result.catch(() => undefined);
    }
  }

  private detectStandaloneMode(): boolean {
    return (
      globalThis.matchMedia('(display-mode: standalone)').matches ||
      (navigator as Navigator & { standalone?: boolean }).standalone === true
    );
  }
}
